const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = '/customer';

const handleError = async (response, fallbackMessage = "حدث خطأ غير متوقع") => {
    let message = fallbackMessage;
    try {
        const data = await response.json();
        message = data?.message || data?.error || fallbackMessage;
    } catch (_) {
        try {
            const text = await response.text();
            message = text || fallbackMessage;
        } catch (_) {}
    }

    console.error(`API Error [${response.status}]: ${message}`);
    throw new Error(message);
};

export const updateCustomerData = async (token, newData) => {
    const response = await fetch(`${BASE_URL}${API_URL}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(newData),
    });

    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تعديل بيانات العميل");
    }

    return await response.json();
};
